import enUS from './en-US'
import idId from './id-ID'

export default {
  'id-ID': idId,
  'en-US': enUS
}
